export default {
  list: {
    title: 'Supplier Contract Management',
    subtitle: 'View supplier contracts synchronized from the Shokz OC contract system',
    filterTitle: 'Contract Filters',
    resultTitle: 'Contracts',
    resultCount: '{count} records',
    exportTitle: 'Supplier Contracts'
  },
  detail: {
    title: 'Supplier Contract Details',
    basicInfo: 'Basic Information',
    readOnly: 'Read-only data from OC',
    parties: 'Signing Entities and Counterparties',
    ourParties: 'Our Signing Entities',
    otherParties: 'Counterparties',
    contractFiles: 'Contract Files',
    lastRefreshedAt: 'Last Local Refresh'
  },
  fields: {
    contractNumber: 'Contract No.',
    contractName: 'Contract Name',
    categoryCode: 'Category Code',
    categoryName: 'Contract Category',
    ourPartyName: 'Our Signing Entity',
    ourPartyNumber: 'Our Entity Code',
    tradingName: 'Counterparty',
    otherPartyNumber: 'Counterparty Code',
    supplierName: 'Linked Supplier',
    statusCode: 'Contract Status',
    validityTag: 'Validity',
    effectivePeriod: 'Effective Period',
    effectiveStartDate: 'Effective From',
    effectiveEndDate: 'Effective To',
    amount: 'Contract Amount',
    belongingDepartmentCode: 'Owning Department',
    principalNum: 'Owner',
    ocLastUpdateDate: 'Last Updated',
    createdAt: 'Created At',
    creatorEmployeeNumber: 'Creator Employee No.',
    creatorName: 'Created By',
    incomeExpenseType: 'Income/Expense Type',
    currency: 'Currency',
    taxRate: 'Tax Rate',
    sourceContractNumber: 'Source Contract No.',
    sourceTemplateNumber: 'Source Template No.',
    operation: 'Actions'
  },
  placeholders: {
    keyword: 'Enter a keyword',
    select: 'Select',
    dateRange: ['Start date', 'End date'],
    amount: 'Enter an amount'
  },
  status: {
    s: 'Signed',
    ar: 'Archived'
  },
  validity: {
    valid: 'Valid',
    expiring: 'Expiring Soon',
    expired: 'Expired'
  },
  incomeExpense: {
    i: 'Income',
    e: 'Expense',
    a: 'Both Income and Expense',
    n: 'Neither Income nor Expense',
    separator: ', '
  },
  partySide: { our: 'Our Entity', other: 'Counterparty' },
  party: {
    name: 'Name',
    code: 'Code',
    side: 'Party Side',
    mainSigner: 'Primary Signer',
    signatory: 'Signatory',
    roleOrder: 'Role Order'
  },
  files: {
    mainContract: 'Main Contract',
    attachments: 'Attachments',
    archiveAttachments: 'Archive Attachments',
    archiveInfo: 'Archive Information',
    fileCount: '{count} files',
    fileName: 'File Name',
    fileType: 'File Type',
    fileSize: 'File Size',
    ocFileId: 'OC File ID',
    uploadedAt: 'Uploaded At',
    status: 'Storage Status',
    archiveNumber: 'Archive No.',
    archiveSubmittedAt: 'Submitted At',
    archiveFileCount: 'Archived Files',
    archivedBy: 'Submitted By'
  },
  fileStatus: {
    stored: 'Stored',
    not_downloaded: 'Not Downloaded',
    downloading: 'Downloading',
    failed: 'Download Failed'
  },
  syncStatus: {
    pending: 'Pending',
    syncing: 'Syncing',
    success: 'Success',
    partial_failure: 'Partially Failed',
    failed: 'Failed'
  },
  sync: {
    source: 'Source',
    sourceName: 'Shokz OC Contract System',
    status: 'Sync Status',
    lastSyncAt: 'Last Sync',
    total: 'Total {count}',
    success: 'Success {count}',
    failure: 'Failed {count}'
  },
  actions: {
    detail: 'Details',
    viewContract: 'View Contract',
    preview: 'Preview',
    download: 'Download',
    refreshList: 'Refresh',
    syncSettings: 'Sync Settings',
    syncNow: 'Run Sync',
    refreshContract: 'Refresh This Contract'
  },
  values: { unmatched: 'Unmatched' },
  messages: {
    loadListFailed: 'Failed to load supplier contracts',
    loadDetailFailed: 'Failed to load supplier contract details',
    connectionNotConfigured: 'The OC connection is not fully configured in Nacos',
    initialStartDateRequired: 'Select the initial sync date in Sync Settings first',
    syncInProgress: 'Supplier contracts are currently syncing',
    syncSubmitted: 'Supplier contract sync task submitted',
    syncFailed: 'Supplier contract sync failed',
    previewUnavailable: 'This file type cannot be previewed online. Download it to view the file.',
    previewBlocked: 'The browser blocked the preview window. Allow pop-ups and try again.',
    fileDownloadFailed: 'Failed to download the contract file',
    refreshSucceeded: 'The contract has been refreshed',
    refreshHidden: 'The contract was refreshed and is no longer visible',
    refreshFailed: 'Failed to refresh the contract. Please try again.'
  }
}
